import axios from "axios";
import { useEffect, useState } from "react";
import { Button, Card, Form, Modal, Pagination, Spinner, Table } from "react-bootstrap";
import { FaUsers } from "react-icons/fa"; // Added for participant icon
import Layout from "../../../../components/Layouts/Layouts/Layout";
import DashboardHeader from "../../../../components/basic/DashboardHeader";
import { formatDateAndTime } from "../../../../components/basic/TimeAndDate";
import { ConfirmModal } from "../../../../components/basic/fileViewModal";
import { getURLbyEndPointV2 } from "../../../../store/api";

const CollaboratorBookings = () => {
    const [bookingsData, setBookingsData] = useState([]);
    const [status, setStatus] = useState("Pending");
    const [appDisApi, setAppDisApi] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [showParticipantsModal, setShowParticipantsModal] = useState(false);
    const [selectedSlot, setSelectedSlot] = useState(null);
    const [selectedParticipants, setSelectedParticipants] = useState([]);

    const handleSlotClick = (slot) => {
        setSelectedSlot(slot);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedSlot(null);
    };

    const handleParticipantsClick = (participants) => {
        setSelectedParticipants(participants);
        setShowParticipantsModal(true);
    };

    const handleCloseParticipantsModal = () => {
        setShowParticipantsModal(false);
        setSelectedParticipants([]);
    };


    const handleInputChange = (itemId, name, value) => {
        setBookingsData((prevData) => {
            const updatedData = prevData.map((item) => {
                if (item._id === itemId) {
                    return {
                        ...item,
                        [name]: value,
                    };
                }
                return item;
            });
            return updatedData;
        });
    };


    const sendB2BReminder = async () => {
        try {
            const res = await axios.get(getURLbyEndPointV2("sendB2BReminder")); 
            if (res.data.status) {
                alert(res.data.message);
                window.location.reload();
            } else { 
                alert(res.data.message);
                window.location.reload();
            }
        } catch (error) {
            alert("Error while sending reminders.");
            console.error("Error:", error);
        }
    };




    const handleApproveRejectBooking = async (userId, status) => {
        setAppDisApi(true);
        //finding user
        const clientData = bookingsData.find((user) => user._id === userId);
        try {
            const res = await axios.post(
                getURLbyEndPointV2("approveRejectB2bRegistration") + userId,
                { status, remark: clientData.remark },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            if (res.data.status) {
                alert(res.data.message);
                setAppDisApi(false);
                window.location.reload();
            } else {
                alert(res.data.message);
                window.location.reload();
            }
        } catch (error) {
            alert("Error while handling booking Data.");
            console.error("Error:", error);
        } finally {
            setAppDisApi(false);
        }
    };


    // Fetch bookings data
    const fetchBookingsData = async () => {
        try {
            const response = await axios.get(getURLbyEndPointV2("getAllB2bRegistration"));
            if (response.status === 200) {
                const data = response.data.data

                // Add properties to each object in the data.data array
                const modifiedData = data.map((item) => {
                    if (item.isApproved === "Pending") {
                        return {
                            ...item,
                            remark: "",
                        };
                    } else if (item.isApproved === "Approved") {
                        return {
                            ...item,
                        };
                    }
                    return item;
                });



                setBookingsData([...modifiedData]);
            } else {
                alert("Failed to fetch bookings data.");
            }
        } catch (error) {
            alert("Error fetching data:", error);
        }
    };

    // Filtering data
    const filteredData = bookingsData.filter((booking) => {
        // Filter by status
        if (status !== "" && booking.status.toLowerCase() !== status.toLowerCase()) {
            return false;
        }

        // Filter by search term (company name or email)
        if (searchTerm !== "") {
            const companyName = booking.clientId?.companyName?.toLowerCase() || "";
            const email = booking.clientId?.email?.toLowerCase() || "";
            if (!companyName.includes(searchTerm.toLowerCase()) && !email.includes(searchTerm.toLowerCase())) {
                return false;
            }
        }

        return true;
    });

    // Pagination logic
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentFiltered = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(filteredData.length / itemsPerPage);

    const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);
    const handlePrevPage = () => setCurrentPage((prev) => Math.max(prev - 1, 1));
    const handleNextPage = () => setCurrentPage((prev) => Math.min(prev + 1, totalPages));

    // Format date
    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
        });
    };

    useEffect(() => {
        fetchBookingsData();
    }, []);

    return (
        <Layout>
            <div className="d-flex flex-column justify-content-center align-items-center px-3">
                <div className="main-width d-flex flex-column">
                    <hr />
                    <DashboardHeader
                        heading="EVENTS / B2B Collaborator Slots"
                        backUrl="/b2b-virtual-forum"
                    />
                    <hr />

                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <div className="d-flex gap-3">
                            <Form.Check
                                inline
                                label="All"
                                name="group1"
                                type="radio"
                                checked={status === ""}
                                onChange={() => setStatus("")}
                            />
                            <Form.Check
                                inline
                                label="Processing"
                                name="group1"
                                type="radio"
                                checked={status === "Pending"}
                                onChange={() => setStatus("Pending")}
                            />
                            <Form.Check
                                inline
                                label="Approved"
                                name="group1"
                                type="radio"
                                checked={status === "Approved"}
                                onChange={() => setStatus("Approved")}
                            />
                            <Form.Check
                                inline
                                label="Rejected"
                                name="group1"
                                type="radio"
                                checked={status === "Rejected"}
                                onChange={() => setStatus("Rejected")}
                            />
                        </div>
                        <div className="d-flex align-items-center gap-3">
                            <ReminderModal sendB2BReminder={sendB2BReminder} />
                            <input
                                className="form-control"
                                style={{ width: "300px" }}
                                type="search"
                                placeholder="Search By company name/ company email"
                                aria-label="Search"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>
                    </div>
                    <div>
                        <Table responsive striped bordered hover>
                            <thead>
                                <tr>
                                    <th style={{ fontSize: "14px", whiteSpace: "nowrap" }}>Sr No.</th>
                                    <th style={{ fontSize: "14px", whiteSpace: "nowrap" }}>Date</th>
                                    <th style={{ fontSize: "14px", whiteSpace: "nowrap" }}>Collaborator Details</th>
                                    <th style={{ fontSize: "14px", whiteSpace: "nowrap" }}>Area of Expertise</th>
                                    <th style={{
                                        fontSize: "14px",
                                        width: "120px",
                                        whiteSpace: "nowrap",
                                    }}>Industry</th>
                                    <th style={{ fontSize: "14px", whiteSpace: "nowrap" }}>Slots</th>
                                    <th style={{ fontSize: "14px", whiteSpace: "nowrap" }}>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentFiltered.length > 0 ? (
                                    currentFiltered.map((booking, index) => (
                                        <tr key={booking._id}>
                                            <td>{indexOfFirstItem + index + 1}.</td>
                                            <td>{formatDateAndTime(booking.createdAt)}</td>
                                            <td>
                                                <div className="max-content">

                                                    <div className="text-primary fs-5 fw-bold">
                                                        {booking.clientId?.companyName || "N/A"}
                                                    </div>
                                                    <div>
                                                        <strong>Name:</strong> {booking.clientId?.firstName || "N/A"} {booking.clientId?.surName || "N/A"}
                                                    </div>
                                                    <div>
                                                        <strong>Email:</strong> {booking.clientId?.email || "N/A"}
                                                    </div>
                                                    <div>
                                                        <strong>Phone No:</strong> {booking.clientId?.phoneNo || "N/A"}
                                                    </div>
                                                    <Button
                                                        variant="outline-primary"
                                                        size="sm"
                                                        className="d-flex align-items-center mt-2 gap-2"
                                                        onClick={() => handleParticipantsClick(booking.participants)}
                                                    >
                                                        <FaUsers /> View Participants ({booking.participants.length})
                                                    </Button>
                                                </div>

                                            </td>
                                            <td>
                                                <div className="max-content">

                                                    {booking.expertise &&
                                                        Object.entries(booking.expertise).map(([key, value], idx) => (
                                                            <div key={idx}>
                                                                <strong>{key}:</strong> {value.join(", ")}
                                                            </div>
                                                        ))}
                                                </div>
                                            </td>
                                            <td>
                                                <div className="max-content">
                                                    <div
                                                        className="d-grid gap-2"
                                                        style={{ gridTemplateColumns: "repeat(2, 1fr)" }} // 3 columns
                                                    >
                                                        {booking.industries?.map((industry, idx) => (
                                                            <Card key={idx} className="bg-primary text-white p-1 text-center">
                                                                {industry}
                                                            </Card>
                                                        ))}
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="max-content">
                                                    <div
                                                        className="d-grid gap-2"
                                                        style={{ gridTemplateColumns: "repeat(3, 1fr)" }} // 3 columns
                                                    >
                                                        {booking.slots.map((slot, idx) => (
                                                            <Card
                                                                key={idx}
                                                                className="cursor-pointer bg-primary p-1 text-center text-white"
                                                                onClick={() => handleSlotClick(slot)}
                                                            >
                                                                {formatDate(slot.date)}<br />
                                                                {slot.startTime}
                                                            </Card>
                                                        ))}
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="max-content">
                                                    {booking.status === "Approved" ||
                                                        booking.status === "Rejected" ? (
                                                        <>
                                                            <h6>
                                                                Remark :{" "}
                                                                <span className="text-secondary">
                                                                    {booking.remark}
                                                                </span>
                                                            </h6>
                                                            <h6>
                                                                Approved At :{" "}
                                                                <span className="text-secondary">
                                                                    {formatDateAndTime(booking.approvedAt)}
                                                                </span>
                                                            </h6>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <div className="max-content">
                                                                <Form.Group>
                                                                    <Form.Control
                                                                        as="textarea"
                                                                        type="text"
                                                                        placeholder="Enter a Remark"
                                                                        rows={3}
                                                                        maxLength={120}
                                                                        onChange={(e) =>
                                                                            handleInputChange(
                                                                                booking._id,
                                                                                e.target.name,
                                                                                e.target.value
                                                                            )
                                                                        }
                                                                        value={booking.remark}
                                                                        name="remark"
                                                                    />
                                                                </Form.Group>

                                                                {booking.remark && (
                                                                    <div className="d-flex justify-content-center gap-3 w-100 mt-3">
                                                                        {appDisApi ? (
                                                                            <Spinner animation="border text-success" />
                                                                        ) : (
                                                                            <>
                                                                                <ConfirmModal
                                                                                    handleApproveRejectEco={
                                                                                        handleApproveRejectBooking
                                                                                    }
                                                                                    userId={booking._id}
                                                                                />
                                                                            </>
                                                                        )}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </>
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={7} className="text-center">
                                            No Matching Data
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </div>

                    {/* Slot Details Modal */}
                    <Modal show={showModal} onHide={handleCloseModal} centered>
                        <Modal.Header closeButton>
                            <Modal.Title>Slot Details</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {selectedSlot && (
                                <div>
                                    <p><strong>Date:</strong> {formatDate(selectedSlot.date)}</p>
                                    <p><strong>Time:</strong> {selectedSlot.startTime} - {selectedSlot.endTime}</p>
                                    <p><strong>Status:</strong> {selectedSlot.isBooked}</p>
                                </div>
                            )}
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleCloseModal}>
                                Close
                            </Button>
                        </Modal.Footer>
                    </Modal>

                    {/* Participants Modal */}
                    <Modal show={showParticipantsModal} onHide={handleCloseParticipantsModal} size="lg" centered>
                        <Modal.Header closeButton>
                            <Modal.Title>Participant Details</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Table responsive striped bordered>
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Name</th>
                                        <th>Designation</th>
                                        <th>Contact</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {selectedParticipants.map((participant, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{participant.firstName} {participant.lastName}</td>
                                            <td>{participant.designation}</td>
                                            <td>{participant.contact}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleCloseParticipantsModal}>
                                Close
                            </Button>
                        </Modal.Footer>
                    </Modal>

                    {totalPages > 1 && (
                        <Pagination>
                            <Pagination.Prev onClick={handlePrevPage} disabled={currentPage === 1} />
                            {Array.from({ length: totalPages }, (_, index) => (
                                <Pagination.Item
                                    key={index + 1}
                                    active={index + 1 === currentPage}
                                    onClick={() => handlePageChange(index + 1)}
                                >
                                    {index + 1}
                                </Pagination.Item>
                            ))}
                            <Pagination.Next onClick={handleNextPage} disabled={currentPage === totalPages} />
                        </Pagination>
                    )}
                </div>
            </div>
        </Layout>
    );
};

export default CollaboratorBookings;



const ReminderModal = ({ sendB2BReminder }) => {
    const [show, setShow] = useState(false);
    const [isSending, setIsSending] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleSendReminder = async () => {
        setIsSending(true);
        try {
            await sendB2BReminder();
            handleClose();
        } catch (error) {
            console.error("Error sending reminders:", error);
        } finally {
            setIsSending(false);
        }
    };

    return (
        <>
            <Button variant="primary" size="sm" onClick={handleShow} disabled={isSending}>
                {isSending ? <Spinner animation="border" size="sm" /> : "Send Reminder"}
            </Button>
            <Modal show={show} onHide={handleClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Send Reminder to All Users</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure you want to send a reminder to all users?
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="success"
                        onClick={handleSendReminder}
                        disabled={isSending}
                    >
                        {isSending ? <Spinner animation="border" size="sm" /> : "Yes, Send"}
                    </Button>
                    <Button variant="secondary" onClick={handleClose} disabled={isSending}>
                        Cancel
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};
